import React, { useState } from 'react';
import { ChatProvider, useChatContext } from './hooks/ChatContext.jsx';
import ChatMessageList from './components/ChatMessageList';
import ChatInput from './components/ChatInput';
import ChatSidebar from './components/ChatSidebar';
import { Sheet, SheetContent, SheetTrigger } from '../../components/ui/sheet';
import { Button } from '../../components/ui/button';
import { Menu } from 'lucide-react';
import ThemeToggle from './components/ThemeToggle';

const ChatPageInner = () => {
  const {
    messages,
    streamLoading,
    streamError,
    sendMessage,
    activeConversation,
  } = useChatContext();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState('');

  const handleSendMessage = async (message) => {
    try {
      await sendMessage(message);
      // Clear initial message after sending
      setInitialMessage('');
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  };

  const handleWelcomeMessageClick = (message) => {
    setInitialMessage(message);
  };

  return (
    <div className="flex h-[100dvh] w-screen bg-background text-foreground overflow-hidden flex-col md:flex-row">
      {/* Desktop sidebar */}
      <div className="hidden md:flex h-full">
        <ChatSidebar />
      </div>
      {/* Mobiili hamburger + Sheet */}
      <div className="absolute top-4 left-4 z-50 md:hidden">
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" aria-label="Avaa keskusteluvalikko">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-64 max-w-full h-full">
            <ChatSidebar />
          </SheetContent>
        </Sheet>
      </div>
      {/* Theme toggle */}
      <div className="absolute top-4 right-4 z-50">
        <ThemeToggle />
      </div>
      {/* Chat content: scrollbar koko oikeassa reunassa */}
      <div className="flex-1 flex flex-col h-full">
        <div className="flex-1 flex flex-col h-0 min-h-0">
          <ChatMessageList 
            messages={messages} 
            loading={streamLoading} 
            error={streamError} 
            contentClassName="flex flex-col items-center w-full" 
            innerClassName="w-full max-w-5xl mx-auto flex flex-col gap-2 p-4 pb-0 justify-end mb-6" 
            onSendMessage={handleWelcomeMessageClick}
          />
        </div>
        <div className="w-full flex justify-center bg-background border-t sticky bottom-0 z-10 pb-[env(safe-area-inset-bottom)] md:static md:pb-0">
          <div className="w-full max-w-3xl">
            <ChatInput 
              onSendMessage={handleSendMessage} 
              isLoading={streamLoading} 
              initialMessage={initialMessage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ChatPage = () => (
  <ChatProvider>
    <ChatPageInner />
  </ChatProvider>
);

export default ChatPage; 